export function fmt(n) {
  if (n == null || n === '') return '–';
  return '₹' + Number(n).toLocaleString('en-IN');
}

export function Badge({ children, color = 'blue' }) {
  const colors = {
    blue:   'bg-blue-100 text-blue-700',
    green:  'bg-green-100 text-green-700',
    red:    'bg-red-100 text-red-700',
    yellow: 'bg-yellow-100 text-yellow-700',
    gray:   'bg-gray-100 text-gray-600',
    orange: 'bg-orange-100 text-orange-700',
  };
  return (
    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${colors[color]}`}>
      {children}
    </span>
  );
}

export function Spinner() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 32 }}>
      <div style={{
        width: 32, height: 32,
        border: '3px solid #2a2f3e',
        borderTop: '3px solid #f59e0b',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export function Card({ children, style = {}, className = '' }) {
  return (
    <div
      className={className}
      style={{
        background: '#1a1f2e',
        border: '1px solid #2a2f3e',
        borderRadius: 12,
        padding: 20,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export function SectionLabel({ children }) {
  return (
    <div style={{ color: '#9ca3af', fontSize: 11, letterSpacing: 2, marginBottom: 10, fontWeight: 700 }}>
      {children}
    </div>
  );
}

// ─── Slip / proof image preview modal ────────────────────────────────────────
// Usage:
//   const [previewSlip, setPreviewSlip] = useState(null);
//   <button onClick={() => setPreviewSlip(url)}>📎 Proof</button>
//   <SlipPreviewModal url={previewSlip} onClose={() => setPreviewSlip(null)} />
export function SlipPreviewModal({ url, onClose }) {
  if (!url) return null;
  const isPdf = url.toLowerCase().includes('.pdf') || url.toLowerCase().includes('application/pdf');
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: '#000000ee',
        zIndex: 9000, display: 'flex', alignItems: 'center',
        justifyContent: 'center', padding: 20, fontFamily: "'DM Mono', monospace",
      }}>
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#1a1f2e', border: '1px solid #2a2f3e',
          borderRadius: 12, overflow: 'hidden',
          maxWidth: '92vw', maxHeight: '92vh',
          display: 'flex', flexDirection: 'column',
        }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '11px 16px', borderBottom: '1px solid #2a2f3e', gap: 16, flexShrink: 0 }}>
          <span style={{ color: '#f59e0b', fontWeight: 700, fontSize: 12, letterSpacing: 1 }}>📎 DEPOSIT SLIP / PROOF</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <a href={url} target="_blank" rel="noreferrer"
              style={{ color: '#6b7280', fontSize: 11, textDecoration: 'none', whiteSpace: 'nowrap' }}>
              ↗ Open in new tab
            </a>
            <button onClick={onClose}
              style={{ background: 'transparent', border: 'none', color: '#9ca3af', fontSize: 22, cursor: 'pointer', lineHeight: 1, padding: '0 2px' }}>
              ×
            </button>
          </div>
        </div>
        {/* Content */}
        <div style={{ overflow: 'auto', flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 200 }}>
          {isPdf
            ? <iframe src={url} title="Deposit slip" style={{ width: '80vw', height: '80vh', border: 'none', display: 'block' }} />
            : <img src={url} alt="Deposit slip" style={{ maxWidth: '88vw', maxHeight: '82vh', objectFit: 'contain', display: 'block' }} />
          }
        </div>
      </div>
    </div>
  );
}

export function Input({ label, ...props }) {
  return (
    <div>
      {label && (
        <label style={{ color: '#6b7280', fontSize: 10, letterSpacing: 1, display: 'block', marginBottom: 4 }}>
          {label}
        </label>
      )}
      <input
        {...props}
        style={{
          background: '#0f1117',
          color: '#f3f4f6',
          border: '1px solid #374151',
          borderRadius: 8,
          width: '100%',
          padding: '9px 12px',
          fontSize: 14,
          fontFamily: 'inherit',
          boxSizing: 'border-box',
          ...props.style,
        }}
      />
    </div>
  );
}
